const $                       = require('jquery');
const _                       = require('underscore');
const endpoint                = require('@readcube/endpoint');
const { icon }                = require('@fortawesome/fontawesome-svg-core');
const evtbus                  = require('../evtbus');
const evtout                  = require('../evtout');
const tpl                     = require('../util/template');

const faIconOpts14  = { classes: ['fa-icon icon-h-14'] };
const faIconOpts200 = { classes: ['fa-icon icon-h-200'] };
const fa = {
  search: require('@fortawesome/pro-light-svg-icons/faSearch').definition,
  file: require('@fortawesome/pro-duotone-svg-icons/faFileAlt').definition,
};

class Preview {
  constructor({ user, container, metadata }) {
    this._user = user;
    this._container = $(container);
    this._render(metadata);
  }

  _render({ hash, meta }) {
    this._elem = $(`
      <div class="preview-container">
        <div class="sidebar"></div>
        <div class="content">
          <aside class="preview">
            ${tpl.if(hash && !this._user.organization?.hide_thumbnails, () => `
              <img class="thumb" src="${thumbnail(hash)}" alt=""></img>
              <div class="search-wrap">
                ${icon(fa.search, faIconOpts14).html}
                <input class="search" placeholder="Search within PDF..."/>
                <div class="search-block"></div>
              </div>
            `)}
            ${tpl.if(!hash || this._user.organization?.hide_thumbnails, () => `
              <i class="file">
                ${icon(fa.file, faIconOpts200).html}
              </i>
            `)}
          </aside>
          <section id="title"></section>
          <section id="abstract"></section>
          <div class="logo">enhanced preview</div>
        </div>
      </div>
    `).appendTo(this._container);

    this._renderTitle({ hash, meta }).appendTo(this._elem.find('#title'));
    this._renderAbstract({ meta }).appendTo(this._elem.find('#abstract'));

    this._elem.find('.search-block').click(e => {
      e.preventDefault();
      e.stopImmediatePropagation();
      evtbus.trigger('search-fulltext');
    });

    this._elem.find('img.thumb').click(() => {
      evtbus.trigger('open-fulltext');
    });

    this._elem.find('a[target=_author_search]').click(function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      evtout.trigger('author-search', [$(this).attr('name'), $(this).attr('href')]);
    });

    if (hash) {
      this._bindSearchWithKeys();
    }
  }

  _bindSearchWithKeys() {
    $(window).on('keydown', e => {
      if (!(e.metaKey || e.ctrlKey)) return;
      if (e.keyCode == 70) {
        e.preventDefault();
        evtbus.trigger('search-fulltext');
      }
    });
  }

  _renderTitle({ hash, meta }) {
    return $(`
      <div>
        <p class="journal">${meta?.journal || ''} ${meta?.year || ''}</p>
        <h1 class="title">${meta?.title || ''}</h1>
        <p class="authors">${authors(meta)}</p>
      </div>
    `);
  }

  _renderAbstract({ meta }) {
    return $(`
      <div>
        ${tpl.if(meta?.abstract, () => `
          <h2>Abstract</h2>
          <p class="abstract">${meta?.abstract}</p>
        `)}
      </div>
    `);
  }
}

function authors(meta) {
  if (_.isEmpty(meta?.authors)) return '';
  return meta?.authors.filter(a => a.name).map(a => {
    const src = `${endpoint.app}/search/readcube?query=author:${encodeURIComponent('"' + a.name + '"')}`;
    return `<a target="_author_search" href="${src}" name="${a.name}">${a.name}</a>`;
  }).join(', ');
}

function thumbnail(hash) {
  return `https://images.readcube-cdn.com/prerendered/${hash}/1.jpg`;
}

module.exports = Preview;
